import { Injectable } from '@angular/core';
import { PopulationDNDGrid } from '../shared/interfaces/population-dnd-grid';
import { AnswerChoice } from '../shared/interfaces/answer-choice';

@Injectable({
  providedIn: 'root',
})
export class DnDGridMatchEvaluator {
  static isCorrect(population: PopulationDNDGrid, answers: string[]): boolean {
    if (answers.length === 0 || population.answers?.length === 0) {
      return false;
    }

    const popAnswerChoices = population.answerChoices as AnswerChoice[];
    const correctAnswers = population.answers as string[];

    // answers arrays should be the same length and be in the same order
    const result = (correctAnswers &&
      correctAnswers.length === answers.length &&
      correctAnswers.every((popAnswer, index) => {
        const popAnswerText = popAnswerChoices?.find(
          choice => choice.id === popAnswer
        )?.choice.texts?.[0]?.text;
        const answerText = popAnswerChoices?.find(
          choice => choice.id === answers[index]
        )?.choice.texts?.[0]?.text;
        const result = answerText && answerText === popAnswerText;
        return result;
      })) as boolean;

    return result;
  }

  static getWrongAnswers(
    population: PopulationDNDGrid,
    answers: string[]
  ): string[] {
    if (answers.length === 0 || population.answers?.length === 0) {
      return [];
    }

    const popAnswerChoices = population.answerChoices as AnswerChoice[];
    const correctAnswers = population.answers as string[];

    // answers arrays should be the same length and be in the same order
    const wrong = answers.filter((answer, index) => {
      const answerText = popAnswerChoices?.find(choice => choice.id === answer)
        ?.choice.texts?.[0]?.text;
      const correctAnswerText = popAnswerChoices?.find(
        choice => choice.id === correctAnswers[index]
      )?.choice.texts?.[0]?.text;
      const result = answerText && answerText !== correctAnswerText;
      return result;
    });

    return wrong;
  }
}
